import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';

import { CampaignForm } from './campaign.form';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ActivatedRoute, Router } from '@angular/router';
import * as stringUtils from 'string';
import { AbstractFormComponent } from '../../../../../shared/crud/component/form.component';
import { Observable } from 'rxjs';
import { ISelectOption } from '../../../../../shared/form/element/base-select/select-option.interface';
import { CampaignStatus } from '../../../../../shared/enum/campaign-status';

@Component({
  templateUrl: './form.component.html'
})
export class AdminCampaignFormComponent extends AbstractFormComponent implements OnInit, AfterViewInit {

  customers$: Observable<any>;
  @ViewChild('formModal', { static: false }) formModal: ModalDirective;
  statuses: any = Object.keys(CampaignStatus).map((status: string) => {
    return {
      value: status,
      label: CampaignStatus[status]
    };
  });

  constructor(formBuilder: CampaignForm,
              httpClient: HttpClient,
              toastrService: ToastrService,
              router: Router,
              route: ActivatedRoute) {
    super(formBuilder, httpClient, toastrService, router, route);
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();

    if (this.formMode === 'update') {
      this.populate().subscribe();
    }
  }

  ngOnInit() {
    super.ngOnInit();

    this.customers$ = Observable.create((obs) => {
      this.httpClient.get<any>('/admin/customer', {
        params: {
          limit: '999'
        }
      })
        .subscribe(
          (response) => {
            obs.next(response.rows.map((row) => {
              return <ISelectOption>{ value: row.id, label: row.name };
            }));
            obs.complete();
          },
          (error: any) => {
            obs.error(error);
            obs.complete();
          }
        );
    });
  }

  protected getUrl(): string {
    return '/admin/campaign';
  }

  protected onSubmit(response: any): void {
    this.toastrService.success('Saved');
    this.close();
    this.router.navigate([ '/admin/campaign' ]);
  }

  generateDomain(): boolean {
    if (this.form.controls['domain'].untouched && this.formMode === 'create') {
      this.form.controls['domain'].setValue(stringUtils(this.form.controls['name'].value).slugify().toString());
    }

    return true;
  }

  close() {
    this.router.navigate([ '../' ], { relativeTo: this.route });
    this.formModal.hide();
  }
}
